<script lang="ts">
    export let options: string[] | number[];

    $: answerText = options.map((option) => option).join(", ");
</script>

<span class="gw-rv-attributes-answers__multi">
    {answerText}
</span>

<style lang="postcss">
    .gw-rv-attributes-answers__multi {
        font-size: 0.875em;
        font-weight: 400;
    }
</style>
